<template>
    <div style="min-height: 66vh;">
        <botao-novo-ajuste
            :possuiRegistroDeAjuste="exibirLinhaDoTempo"
            @abrirModalNovoAjuste="tratarEventoAbrirModalNovoAjuste"
        />
        <div v-if="exibirLinhaDoTempo">
            <linha-do-tempo-ajuste
                :items="items"
                @abrirModalMaisDetalhes="redirecionaParaModalDetalhes"
                @acessarVisualizacao="acessarVisualizacao"
            />
        </div>
        <router-view
            @fecharModalAjuste="fecharModalAjuste"
            @atualizarNovoAjuste="tratarEventoAtualizarNovoAjuste"
            @acessarVisualizacao="acessarVisualizacao"/>
    </div>
</template>

<script>
    import BotaoNovoAjuste from './BotaoNovoAjuste.vue'
    import {actionTypes} from '@/core/constants'
    import {mapActions} from 'vuex'
    import LinhaDoTempoAjuste from './LinhaDoTempoAjuste.vue'

    export default {
        name: 'NovoAjuste',
        components: {BotaoNovoAjuste, LinhaDoTempoAjuste},

        data() {
            return {
                reavaliacao: {},
                patrimonioId: null,
                orgaos: [],
                items: [],
                tipo: null,
                situacao: null,
                exibirLinhaDoTempo: false,
                possuiRegistroDeAjuste: false,
                exibirTooltipAjuste: false,
            }
        },
        async mounted() {
            await this.setarIdPatrimonio()
            await this.buscarPatrimonio()
            await this.buscarAjustes()
        },
        methods: {
            ...mapActions([
                actionTypes.AJUSTE.BUSCAR_AJUSTE_POR_PATRIMONIO,
                actionTypes.PATRIMONIO.VISUALIZAR_PATRIMONIO_POR_ID,
                actionTypes.COMUM.BUSCAR_TODOS_ORGAOS
            ]),
            setarIdPatrimonio() {
                this.patrimonioId = this.$route.params.id
            },
            async buscarPatrimonio() {
                await this.visualizarPatrimonioPorId(this.patrimonioId)
            },
            async buscarAjustes(){
                const resultado = await this.buscarAjustePorPatrimonio({idPatrimonio: this.$route.params.id})
                this.items = resultado.items
                this.deveExibirLinhaDoTempo()
            },
            deveExibirLinhaDoTempo() {
                this.exibirLinhaDoTempo = this.items.length !== 0
            },

            async tratarEventoAtualizarNovoAjuste(novoAjuste) {
                this.estaInserindo = false
                this.novoAjuste = await this.atualizarNovoAjuste(novoAjuste)
            },

            async fecharModalAjuste() {
                await this.$router.push({
                    name: 'NovoAjuste',
                    params: {id: this.patrimonioId}
                })
                await this.buscarAjustes()
                await this.buscarPatrimonio()
            },
            async tratarEventoAbrirModalNovoAjuste() {
                await this.$router.push({
                    name: 'ModalNovoAjuste',
                    params: {id: this.patrimonioId}
                })
            },
            async redirecionaParaModalDetalhes(ajuste) {
                await this.$router.push({
                    name: 'ModalAjusteDetalhes',
                    params: {ajusteId: ajuste.id}
                })
            },
            async acessarVisualizacao(ajuste) {
                await this.$router.push({
                    name: 'AjusteDetalhe',
                    params: {ajusteId: ajuste.id},
                    query: {rotaOrigem: 'NovoAjuste'}
                })
            }
        }
    }
</script>
